import styled from 'styled-components';

export const PageLoadingWrapper = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  z-index: 555;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.bg};

  img {
    width: 200px;
    height: auto;
  }
`;